import { get } from "svelte/store"
import { json } from "svelte-i18n"
import { toastAlert } from "$lib/commons-web2/toast-alert"
import { InvalidSessionError } from "@tastyworks/tastyworks-api"
import session from "$lib/tastyworks-rest/session.ts"

type ErrorName = "RestError"

export abstract class HandledError extends Error {
  protected constructor(name: ErrorName, message: string) {
    super(message)
    this.name = name
  }

  protected abstract get textBundle(): Record<string, any>

  abstract get userFriendlyDisplay(): { title: string; message: string }

  abstract isSentryIgnored(): boolean
}

export class AbortSubmissionError extends Error {
  constructor() {
    super("Uncaught AbortSubmissionError thrown outside Form context")
  }
}

export class GlobalErrorHandler {
  isTerminal: boolean = false

  private get textBundle() {
    return get(json)("errors")
  }

  toast() {
    const { title, message } = this.textBundle.global
    toastAlert("error", title, message)
  }

  static redirectToSignup() {
    session.clear()
    window.location.assign("/signup")
  }

  // Handles errors within SvelteKit's load functions and initial rendering
  static handleLoadError({ error }: { error: unknown }) {
    console.error(error)

    if (error instanceof InvalidSessionError) {
      GlobalErrorHandler.redirectToSignup()
    }
  }

  // Handles all other synchronous and async errors
  handleError(error: unknown) {
    this.isTerminal = true
    console.error(error)

    if (error instanceof InvalidSessionError) {
      GlobalErrorHandler.redirectToSignup()
      return
    }

    this.toast()
  }
}
